var $5ece97d9dd84c4a6$exports = {};
$5ece97d9dd84c4a6$exports = {
    "maximum": `Maksimum`,
    "minimum": `Minimum`
};


export {$5ece97d9dd84c4a6$exports as default};
//# sourceMappingURL=da-DK.module.js.map
